// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"videos_videoContainer__t6dWD"};